import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { UserService } from '../../../../services/user.service';
import { DatePipe } from '@angular/common';
import { DateObject, Document_Upload_File, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from '../../../../models/common';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SiteEvaluation } from 'src/app/models/um/organization';
import { FileService } from 'src/app/services/file.service';


@Component({
  selector: 'app-ist-site-evaluation-view-modal',
  templateUrl: './ist-site-evaluation-view-modal.component.html',
  styleUrls: ['./ist-site-evaluation-view-modal.component.scss']
})
export class IstSiteEvaluationViewModalComponent implements OnInit {

  uploadedFiles = [];
  @Input() public Content: any;
  itemId;
  formFields;
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  FilesList;
  contactPersonOptions = [];
  VisitedFiles = [];
  UploadedFilesList = [];
  UploadedFilesListCopy = [];
  userType: string = "";
  minDate: Date;
  siteevaluation: SiteEvaluation;
  siteEvaluationForm: UntypedFormGroup;
  content: any;
  ExpdateofVisit: Date;
  AssignDate: Date;
  heading: string;
  disabledDates: Date[] = [];
  action: Subject<any> = new Subject();
  ApplicationID: any;
  document_attach_list: Document_Upload_File[] = [];
  myDate1 = new Date();
  myDate = new Date(this.myDate1.setDate(new Date().getDate() - 1))
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  staticformFields: any;
  submittedresponse: SCREEN_RESPONSE[] = [];
  permission: string = "";
  tooltipValue: any;
  IsFormToched: boolean = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  operations: any = [];
  ModelData: any = null;
  Status: any;
  ID: any;
  Site_Visit_Date: any;
  visitUploadedFiles: any[] = [];
  Attachments: any[] = [];
  screenName: string = "";
  genInfoFieldControls: any;
  Application_Type_ID: string = "";
Currency_ID: string="";
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public datepipe: DatePipe,
    public commonService: CommonService,
    public fileService: FileService,
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    this.minDate = new Date();
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
      this.GetScreenConfigControls('SCR-013');
      if (!this.ApplicationID) {
        this.GetIstGenInfoScreenConfigControls();
      }
    });

    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.datashareService.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
      if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.datashareService.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.files = [];

    this.userType = this.userService.getUserType();

    if (this.Content.heading === 'Edit') { // Edit mode
      this.getRecordFprEdit();
      this.permission = 'Edit';
    } else if (this.Content.heading === 'View') { //View mode 
      this.getRecordFprEdit();
      this.permission = 'view';
    }
  }

  showFiles() {
    let files = '';
    this.uploadedFiles = [];

    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }

    }

    for (let i = 0; i < this.files.length; i++) {
      let newAttachment = this.files[i].name;
      this.uploadedFiles.push(newAttachment);
    }

    return files;
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }


  getRecordFprEdit() {
    let today = new Date(); today.setHours(0, 0, 0, 0);
    this.summaryService.getScreenDataForEdit("api/ISTSiteevaluation/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
      if (result != null) {
        if (result["Modal"] != null) {
          this.Status = result["Modal"]["STATUS"];
        }
        this.setFormPermissions();
        this.BindDataToDynamicControls();
        this.BindDataToStaticControls(result);
      }
    });
  }

  SaveSiteEvalution() {
    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields?.length > 0) {
        for (let i = 0; i < this.staticformFields?.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }

        let uploadData = new FormData();
        //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
        let FinalControls = _.cloneDeep(this.staticformFields);
        FinalControls.forEach((item) => {
          switch (item.CONTROL) {
            case 10:
              item.ControlValue = null;
              break;
          }
        });
        uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
        uploadData.append("Appid", this.Content.content.id);
        uploadData.append("ModuleID", "2");

        if (this.document_attach_list != null && this.document_attach_list.length > 0) {
          for (let i = 0; i < this.document_attach_list.length; i++) {
            this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
            uploadData.append(("" + (i + 1)), this.document_attach_list[i].File);
          }
        }

        if (this.Content.heading == "Add") {
          if (!this.ApplicationID) {
            this.SaveIST_GI_APP().subscribe((res) => {
              if (res.Status === 0) {
                this.ApplicationID = res["TransactionID"];
                this.datashareService.setApplicationID(this.ApplicationID);
                uploadData.append("ApplicationID", this.ApplicationID);
                this.summaryService.FilesInsert("api/ISTSiteevaluation/Insert", uploadData).subscribe(result => {
                  if (result.Status === 0) {
                    this.commonService.SuccessBanner(this.screenName + ' added successfully');
                    this.modalRef.close('yes');
                    this.commonService.refreshPage(this.ApplicationID);
                  }
                  else {
                    this.commonService.ValidationBanner(result.Message);
                  }
                });
              }
            });

          } else {
            uploadData.append("ApplicationID", this.ApplicationID);
            this.summaryService.FilesInsert("api/ISTSiteevaluation/Insert", uploadData).subscribe(result => {
              if (result.Status === 0) {
                this.commonService.SuccessBanner(this.screenName + ' added successfully');
                this.modalRef.close('yes');
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
            });
          }
        }
        else {
          let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
          if (!inactiveValueControls || inactiveValueControls.length == 0) {
            uploadData.append("ApplicationID", this.ApplicationID);
            this.summaryService.FilesInsert("api/ISTSiteevaluation/Update", uploadData).subscribe(result => {
              this.IsFormToched = false;
              if (result.Status === 0) {
                if (result.ErrorCode === "NOCHANGES") {
                  this.getRecordFprEdit();
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner(this.screenName + ' updated successfully');
                  this.modalRef.close('yes');
                }
              }
              else {
                this.getRecordFprEdit();
                this.commonService.ValidationBanner(result.Message);
              }
            });
          } else {
            let dataMsg = inactiveValueControls.join("</br>");
            this.commonService.ValidationBanner(dataMsg);
          }
        }
      }
    }
  }


  ComparingDates(oldDate: any, newDate: any) {
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }

  DeleteSavedUpload(item): void {
    let code = item;
    this.commonService.CheckIsFileIsRefereancedInReviw(item).subscribe((x) => {
      if (x["Status"] == 2 && x["Data"] == false) {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else {
        let index = this.UploadedFilesList.findIndex(x => x.ID == code);
        this.UploadedFilesList.splice(index, 1);
      }
    });


  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removedz
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }


  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.Content.content.id, (ScreenData) => {
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      this.screenName = ScreenData.NAME;
      let fields = this.staticformFields.filter(x => x.IS_STATIC == false);
      fields.forEach((item) => {
        item.Display_Field = true;
      });
      this.getRecordFprEdit();
    });
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    this.staticformFields.forEach((item) => {
      if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
        switch (item.CONTROL) {
          case 1:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 2:
          case 3:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 4:
            if (!item.ControlValue && item.Display_Field) {
                          $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                          $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                          message += `Please select ${item.LABEL} <br/>`;
                          isValid = false;
                        }
            break;
          case 5:
          case 11:
            if (!item.ControlValue && item.Display_Field) {
                          $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                          $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                          message += `Please enter ${item.LABEL} <br/>`;
                          isValid = false;
                        }
            break;

          case 10:

            if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0 && item.Display_Field)) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }


            break;
          case 6:
            let seletedItem = "";
            for (let c = 0; c < item.SourceItems.length; c++) {
              if (item.SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = item.SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + item.SourceItems[c].value;
              }
            }
            item.ControlValue = seletedItem;
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 7:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 8:
            if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0 && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 9:
            break;
        }
      }
    });

    //Check atleast single field value exists
    if (isValid) {
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter atleast one field. <br/>`;
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  private setFormPermissions() {
    if (this.permission == "view") {
      this.operations = [];
    }
    else {
      this.operations = [
        { name: 'SaveSiteEvalution', type: 'submit', callback: this.SaveSiteEvalution, self: this }
      ]
    }

  }


  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-013";
      sr.RowId = this.Content.content.id;
      sr.AppId = this.ApplicationID;
      this.summaryService.getISTScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (let i = 0; i < this.staticformFields.length; i++) {
            let response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                this.staticformFields[i].Display_Field = true;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  let options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].Display_Field = true;
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                this.staticformFields[i].Display_Field = true;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }

                }

              }
              else {
                this.staticformFields[i].Display_Field = true;
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.staticformFields[i].Display_Field = true;
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
              }
            }

          }
        }

      });
    }
  }

  BindDataToStaticControls(MainObjData: any) {
    let today = new Date(); today.setHours(0, 0, 0, 0);
    for (let i = 0; i < this.staticformFields?.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "APPLICATION_ID":
          this.staticformFields[i].ControlValue = MainObjData.Modal?.APPLICATION_ID;
          break;
        case "CONTACT_PERSON_ID":
          this.staticformFields[i].Display_Field = true;

          this.staticformFields[i].ControlValue = MainObjData.Modal?.CONTACT_PERSON_ID;
          break;
        case "CONTACT_PERSON_DESIGNATION":
          this.staticformFields[i].Display_Field = true;

          this.staticformFields[i].ControlValue = MainObjData.Modal?.CONTACT_PERSON_DESIGNATION;
          break;
        case "EVALUATION_TYPE_ID":
          this.staticformFields[i].Display_Field = true;

          this.staticformFields[i].ControlValue = MainObjData.Modal?.EVALUATION_TYPE_ID;
          break;
        case "EXPECTED_VISIT_DATE":
          this.staticformFields[i].Display_Field = true;
          if (MainObjData.Modal?.EXPECTED_VISIT_DATE != null && MainObjData.Modal?.EXPECTED_VISIT_DATE != undefined) {

            MainObjData.Modal.EXPECTED_VISIT_DATE = this.commonService.getdisplayedDate(MainObjData.Modal?.EXPECTED_VISIT_DATE);
            let date = new Date(this.ExpdateofVisit);
            setTimeout(() => {
              while (date < today) {
                this.disabledDates.push(new Date(date));
                date.setDate(date.getDate() + 1);
              }
            }, 0);

            if (MainObjData.Modal?.EXPECTED_VISIT_DATE < new Date()) {
              this.minDate = MainObjData.Modal?.EXPECTED_VISIT_DATE;
            }
          }
          this.staticformFields[i].ControlValue = MainObjData.Modal?.EXPECTED_VISIT_DATE;
          break;
        case "NOTES":
          this.staticformFields[i].Display_Field = true;

          this.staticformFields[i].ControlValue = MainObjData.Modal?.NOTES;
          break;
        case "REPRESENTATIVE_ID":
          this.staticformFields[i].Display_Field = true;

          this.staticformFields[i].ControlValue = MainObjData.Modal?.REPRESENTATIVE_ID;
          break;
        case "STUDY_CENTER_ID":
          this.staticformFields[i].Display_Field = true;

          this.staticformFields[i].ControlValue = MainObjData.Modal?.STUDY_CENTER_ID;
          break;
        case "ORGANIZATION_ID":
          this.staticformFields[i].ControlValue = MainObjData.Modal?.ORGANIZATION_ID;
          break;
        case "ASSIGN_DATE":
          this.staticformFields[i].Display_Field = true;

          if (MainObjData.Modal?.ASSIGN_DATE != null && MainObjData.Modal?.ASSIGN_DATE != undefined) {

            MainObjData.Modal.ASSIGN_DATE = this.commonService.getdisplayedDate(MainObjData.Modal?.ASSIGN_DATE);
            let date = new Date(this.ExpdateofVisit);
            setTimeout(() => {
              while (date < today) {
                this.disabledDates.push(new Date(date));
                date.setDate(date.getDate() + 1);
              }
            }, 0);

            if (MainObjData.Modal?.ASSIGN_DATE < new Date()) {
              this.minDate = MainObjData.Modal?.ASSIGN_DATE;
            }
          }

          this.staticformFields[i].ControlValue = MainObjData.Modal?.ASSIGN_DATE;
          break;
        case "STATUS":
          this.staticformFields[i].ControlValue = MainObjData.Modal?.STATUS;
          this.Status = MainObjData.Modal?.STATUS;
          break;
        case "SiteEval_CF":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].UploadFiles = MainObjData.FilesList;
          break;
        case "SiteEval_ActualDate":
          this.staticformFields[i].ControlValue = MainObjData.Modal?.ASSIGN_DATE;
          this.Site_Visit_Date = MainObjData.Modal?.ASSIGN_DATE;

          break;
        case "ActualDate_CF1":
          this.staticformFields[i].UploadFiles = MainObjData.StatusFilesList;
          this.visitUploadedFiles = MainObjData.StatusFilesList;
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }

  }

  // ApplyConditions($event, question, makeNull) {
  //   let value = $event.value;
  //   if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
  //     question.Control_Condtions = [];
  //   }
  //   let displayControlIDS = [];
  //   let hideControlIDS = [];
  //   let enableControlIDS = [];
  //   let disbledControlIDS = [];


  //   question.Control_Condtions.forEach((item) => {
  //     if (item.Mapped_Control_Value == value) {
  //       item.ConditionsList.forEach((otemCon) => {
  //         switch (otemCon.Mapped_Condtion) {
  //           case "1": //display
  //             if (displayControlIDS.length == 0) {
  //               displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (disCntrIds && disCntrIds.length > 0) {
  //                 disCntrIds.forEach((id) => {
  //                   if (!displayControlIDS.includes(id)) {
  //                     displayControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }

  //             break;
  //           case "2": //enabled
  //             if (enableControlIDS.length == 0) {
  //               enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (enableCntrIds && enableCntrIds.length > 0) {
  //                 enableCntrIds.forEach((id) => {
  //                   if (!enableControlIDS.includes(id)) {
  //                     enableControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }
  //             break;
  //           case "3": //hide
  //             if (hideControlIDS.length == 0) {
  //               hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (hideCntrIds && hideCntrIds.length > 0) {
  //                 hideCntrIds.forEach((id) => {
  //                   if (!hideControlIDS.includes(id)) {
  //                     hideControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }

  //             break;

  //           case "4": //disabled
  //             if (disbledControlIDS.length == 0) {
  //               disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (disableCntrIds && disableCntrIds.length > 0) {
  //                 disableCntrIds.forEach((id) => {
  //                   if (!disbledControlIDS.includes(id)) {
  //                     disbledControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }
  //             break;
  //         }

  //       });
  //     }
  //   })


  //   //default
  //   if (value != "") {
  //     this.staticformFields.forEach((con) => {
  //       if (displayControlIDS.indexOf(con.ID) > -1) {
  //         con.IS_Dependent_Display = true;
  //         if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //         if (con.CONTROL == "10") {
  //           con.ControlValue = [];
  //         }
  //         if (con.CONTROL == "4")
  //           this.UpdateParentChildDetails(con);
  //       }
  //       if (hideControlIDS.indexOf(con.ID) > -1) {
  //         con.IS_Dependent_Display = false;
  //         if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //         if (con.CONTROL == "10") {
  //           con.ControlValue = [];
  //         }
  //         if (con.CONTROL == "4")
  //           this.UpdateParentChildDetails(con);
  //       }
  //       if (enableControlIDS.indexOf(con.ID) > -1) {
  //         con.IS_Dependent_Enabled = true;
  //         if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //         if (con.CONTROL == "10") {
  //           con.ControlValue = [];
  //         }
  //         if (con.CONTROL == "4")
  //           this.UpdateParentChildDetails(con);
  //       }
  //       if (disbledControlIDS.indexOf(con.ID) > -1) {
  //         con.IS_Dependent_Enabled = false;
  //         if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //         if (con.CONTROL == "10") {
  //           con.ControlValue = [];
  //         }
  //         if (con.CONTROL == "4")
  //           this.UpdateParentChildDetails(con);
  //       }
  //     });
  //   }

  // }

  ApplyConditions($event, question, makeNull) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })
    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display == true) {

        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Enabled == true) {

        }
      });
    }
  }


  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }

  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
    //let Flag = true;
    let Isexe = false;
    let Is5oMB = false;
    let IscrdDownload = false;

    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;        
      }
      else if (file != null && (ext == 'crdownload')) {
        IscrdDownload = true;
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else if (IscrdDownload) {
      this.commonService.ValidationBanner("The system does not support .crdownload files. Please choose a different file format to save the details.")
    }
    else {

    }
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }


  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
  }


  GetIstGenInfoScreenConfigControls() {
    this.commonService.GetScreenConfigControls('SCR-001', '', '', (ScreenData) => {
      this.genInfoFieldControls = ScreenData["SCREEN_CONTROL"];
    });
  }

  SaveIST_GI_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.genInfoFieldControls));
    uploadData.append("Appid", '');
    uploadData.append("Application_Type_ID", this.Application_Type_ID);
    uploadData.append("Currency_ID", this.Currency_ID);
    return this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", uploadData);
  }
}
